import type { Field, Row } from "./types";

const brl = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export function formatCurrency(value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  return Number.isNaN(n) ? "—" : brl.format(n);
}

export function formatDate(value: unknown): string {
  if (!value) return "—";
  const d = new Date(value as string);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("pt-BR", { timeZone: "UTC" });
}

/**
 * Hora no formato que o `<input type="time">` entende (HH:MM).
 * O banco pode devolver "14:30", "14:30:00" ou "14:30:00.000" dependendo de como
 * o valor foi gravado — o input recusa qualquer coisa fora de HH:MM e o campo
 * apareceria vazio, como se o horário não tivesse sido salvo.
 */
export function horaCurta(value: unknown): string {
  const s = String(value ?? "").trim();
  const m = s.match(/^(\d{1,2}):(\d{2})/);
  if (!m) return "";
  return `${m[1]!.padStart(2, "0")}:${m[2]}`;
}

/** Formata o valor de uma célula conforme o tipo do campo. */
export function formatCell(field: Field, row: Row): string {
  if (field.ref === "colaboradores") {
    return row.colaborador_nome ?? "—";
  }
  const value = row[field.name];
  if (value === null || value === undefined || value === "") return "—";
  switch (field.type) {
    case "currency":
      return formatCurrency(value);
    case "date":
      return formatDate(value);
    case "time":
      return horaCurta(value) || "—";
    case "password":
      return "••••••";
    // Competências marcadas: na tabela mostra as 2 primeiras + "+N" para não
    // estourar a coluna (a lista completa aparece ao editar). Quem decide se a
    // coluna aparece é o CARGO do colaborador (ver cargos-operacional.ts) —
    // isso é resolvido no CrudView, que tem a tabela de Cargos e Salários.
    case "skills": {
      const itens = String(value)
        .split(/[,;\n]+/)
        .map((s) => s.trim())
        .filter(Boolean);
      if (itens.length <= 2) return itens.join(", ");
      return `${itens.slice(0, 2).join(", ")} +${itens.length - 2}`;
    }
    default:
      return String(value);
  }
}
